<h1>{{notification.title}}</h1>
<p [innerHTML]="notification.body | newline"></p>
<button
    class="default"
    angulartics2On="click"
    angularticsCategory="Feature Request"
    angularticsAction="{{notification.button}}"
    [requestConfirmation]="notification.button === 'Request Tenant'"
    (click)="onClose()"
>
    {{notification.button}}
</button>